import React, { useState, useEffect } from "react";
import { auth } from "./firebase";
import { sendPasswordResetEmail } from "firebase/auth";
import { toast } from "react-toastify";
import { useNavigate, Link } from "react-router-dom";
import "./LoginForm.css";
import { FaEnvelope } from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import { fetchData, selectIsLoading } from "../../mainApp/features/DataSlice/dataSlice";
import LoadingPage from "../components/TechnicalTabs/LoadingPage";
import ErrorPage from "../components/TechnicalTabs/ErrorPage";
import { translateFirebaseError } from "./Utility/firebaseErrorTranslator";

function ResetPassword() {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isEmailSent, setIsEmailSent] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const dataLoading = useSelector(selectIsLoading);
  const resetToastId = 'reset-password-toast';

  useEffect(() => {
    dispatch(fetchData());
  }, [dispatch]);

  useEffect(() => {
    if (dataLoading === "success") {
      // Komponent gotowy do użycia
    }
  }, [dataLoading]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isLoading) return;

    if (!email.trim()) {
      toast.error("Proszę wprowadzić adres email", {
        position: "bottom-center",
        toastId: resetToastId
      });
      return;
    }

    setIsLoading(true);

    try {
      await sendPasswordResetEmail(auth, email);
      setIsEmailSent(true);
      toast.success("Email z linkiem do resetowania hasła został wysłany!", {
        position: "top-center",
        autoClose: 3000,
      });
    } catch (error) {
      console.error('Błąd wysyłania emaila resetującego:', error);
      
      const translatedError = translateFirebaseError(error.code, 'reset-password');
      
      toast.error(translatedError, {
        position: "bottom-center",
        toastId: resetToastId
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleBackToLogin = () => {
    navigate("/login");
  };

  let returned;

  switch (dataLoading) {
    case "loading":
      returned = <LoadingPage />;
      break;
    case "success":
      returned = (
        <div className="wrapper">
          <form onSubmit={handleSubmit}>
            <h1>Resetowanie hasła</h1>
            
            {!isEmailSent ? (
              <>
                <div className="input-box">
                  <input
                    type="email"
                    placeholder="Wprowadź swój email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={isLoading}
                  />
                  <FaEnvelope className="icon" />
                </div>

                <button type="submit" disabled={isLoading}>
                  {isLoading ? "Wysyłanie..." : "Wyślij email resetujący"}
                </button>
              </>
            ) : (
              <div style={{ 
                background: 'rgba(76, 175, 80, 0.2)', 
                color: '#4CAF50', 
                padding: '15px', 
                borderRadius: '8px',
                marginBottom: '20px',
                border: '1px solid rgba(76, 175, 80, 0.3)'
              }}>
                ✅ Email został wysłany! Sprawdź swoją skrzynkę odbiorczą i spam.
              </div>
            )}

            <div className="register-link">
              <p>
                <a href="#" onClick={handleBackToLogin}>Powrót do logowania</a>
              </p>
            </div>

            <div style={{ 
              marginTop: '20px', 
              padding: '15px', 
              background: 'rgba(255, 255, 255, 0.1)', 
              borderRadius: '8px',
              fontSize: '14px',
              color: 'rgba(255, 255, 255, 0.8)',
              border: '1px solid rgba(255, 255, 255, 0.2)'
            }}>
              <strong style={{ color: 'white' }}>Wskazówki:</strong>
              <ul style={{ margin: '10px 0 0 20px' }}>
                <li>Sprawdź folder spam, jeśli nie widzisz emaila</li>
                <li>Link jest ważny przez 1 godzinę</li>
                <li>Po kliknięciu w link będziesz mógł ustawić nowe hasło</li>
                <li>Nowe hasło musi mieć co najmniej 6 znaków</li>
              </ul>
            </div>

            <div className="legal-links">
              <Link to="/regulations">Regulamin</Link>
              <span className="separator">|</span>
              <Link to="/policy">Polityka Prywatności</Link>
            </div>
          </form>
        </div>
      );
      break;
    case "error":
      returned = <ErrorPage />;
      break;
    default:
      returned = <LoadingPage />;
  }

  return returned;
}

export default ResetPassword;
